import { cloneDeep } from 'lodash/lang'

const setWaiverFormField = (state, action) => {
  const { waiverType, fieldName, fieldValue } = action

  const forms = cloneDeep(state)
  const form = forms.find(f => f.waiverType == waiverType)
  if (form) {
    form[fieldName] = fieldValue
  } else {
    forms.push({
      waiverType,
      [fieldName]: fieldValue
    })
  }

  return forms
}

export default setWaiverFormField
